var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Valid Field"),React.createElement("desc",{"key":1},"Valid form field"),React.createElement("g",{"clipPath":"url(#clip0_494_41441)","key":2},[React.createElement("circle",{"cx":"8","cy":"8","r":"8","fill":"#65A30D","key":0}),React.createElement("path",{"d":"M12 6L6.5 11L4 8.72727","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":3},React.createElement("clipPath",{"id":"clip0_494_41441"},React.createElement("rect",{"width":"16","height":"16","fill":"white"})))]);
}

Check.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Check;

Check.default = Check;
